var o = "_footer_1oxzl_43",
  n = "_container_1oxzl_57",
  t = "_ul_1oxzl_62",
  _ = "_sectionsContainer_1oxzl_71",
  e = "_col_1oxzl_86",
  s = "_title_1oxzl_91",
  i = "_linkItem_1oxzl_100",
  l = "_link_1oxzl_100",
  c = "_bottomContainer_1oxzl_115",
  r = "_bottomLinks_1oxzl_127",
  a = "_logo_1oxzl_134",
  x = "_newsletter_1oxzl_138",
  z = "_input_1oxzl_145",
  b = "_mobileInput_1oxzl_151",
  m = "_from_1oxzl_163",
  p = "_subscribeIcon_1oxzl_187",
  u = "_spinnerContainer_1oxzl_196",
  k = "_spinner_1oxzl_196",
  C = "_socialMedia_1oxzl_218",
  I = {
    footer: o,
    container: n,
    ul: t,
    sectionsContainer: _,
    col: e,
    title: s,
    linkItem: i,
    link: l,
    bottomContainer: c,
    bottomLinks: r,
    logo: a,
    newsletter: x,
    input: z,
    mobileInput: b,
    from: m,
    subscribeIcon: p,
    spinnerContainer: u,
    spinner: k,
    socialMedia: C
  };
export { c as bottomContainer, r as bottomLinks, e as col, n as container, I as default, o as footer, m as from, z as input, l as link, i as linkItem, a as logo, b as mobileInput, x as newsletter, _ as sectionsContainer, C as socialMedia, k as spinner, u as spinnerContainer, p as subscribeIcon, s as title, t as ul };